module.exports = __webpack_public_path__ + "img/TV_clean_box18.afc13c42.jpg";